import React, { useState } from "react";
import { Input, InputProps } from "./input";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";

type PasswordInputProps = Omit<InputProps, "type">;

//Icon styles
const iconContainerStyle = "absolute inset-y-0 right-0 pr-0.5 flex items-center cursor-pointer";
const baseIconStyle = "text-l text-light-slate p-3.5 bg-neutral-white";
const showIcon = "fa-sharp fa-regular fa-eye";
const hideIcon = "fa-sharp fa-regular fa-eye-slash";

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setPasswordVisible(!passwordVisible);
  };

  const iconStyle: string[] = [baseIconStyle];

  if (props.state != "disabled") {
    if (passwordVisible) {
      iconStyle.push(hideIcon);
    } else {
      iconStyle.push(showIcon);
    }
  } else {
    iconStyle.push("hidden");
  }

  return (
    <Input {...props} type={passwordVisible ? "text" : "password"}>
      <button
        className={iconContainerStyle}
        onClick={(event) => togglePasswordVisibility(event)}
        type="button"
        aria-label="Toggle view password"
      >
        <i className={iconStyle.join(" ")} />
      </button>
    </Input>
  );
};
